// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__IQPln","content":"Contact_content__5Nl2F","contact":"Contact_contact__UGBZE","copyright":"Contact_copyright__YJpig"};